<div class="view-email-container">

<!-- Modal header -->
<div class="menu">
  <span class="menu-heading">{{ heading }}</span>
  <span class="close-btn" (click)="close()">&#x2715;</span>
</div>

<div class="view-body">

  <!-- 1. Subject -->
  <div class="subject-row">{{ emailData?.Subject }}</div>

  <!-- 2. Two-column: LHS To/From/CC, RHS buttons + date -->
  <div class="meta-actions-row">

    <div class="meta-left">
      <div class="meta-field">
        <span class="meta-label">To: </span>
        <div class="meta-value">
          <span class="" *ngFor="let addr of toAddresses">{{ addr }}</span>
        </div>
      </div>
      <div class="meta-field">
        <span class="meta-label">From: </span>
        <div class="meta-value">{{ emailData?.From }}</div>
      </div>
      <div class="meta-field" *ngIf="ccAddresses?.length > 0">
        <span class="meta-label">CC: </span>
        <div class="meta-value">
          <span class="" *ngFor="let addr of ccAddresses">{{ addr }}</span>
        </div>
      </div>
    </div>

    <div class="meta-right">
      <!-- <div class="action-buttons">
        <button class="outline-btn large" (click)="reply()"><img src="{{ baseHref }}/assets/images/email/icon-reply.svg" /> Reply</button>
        <button class="outline-btn large" (click)="replyAll()"><img src="{{ baseHref }}/assets/images/email/icon-reply-all.svg" /> Reply All</button>
        <button class="outline-btn large" (click)="forward()"><img src="{{ baseHref }}/assets/images/email/icon-forward.svg" /> Forward</button>
      </div> -->
      <div class="received-date">{{ formatDate(emailData?.Date) }}</div>
    </div>

  </div>

  <!-- 3. Attachments -->
  <ng-container *ngIf="attachments?.length > 0">
    <div class="attachments-section">
      <div class="section-label"> Attachments <span class="">({{ attachments.length }})</span></div>
      <div class="attachment-list">
        <div class="attachment-item" *ngFor="let att of attachments" (click)="downloadAttachment(att.AttachmentURL)">
          <img src="{{ baseHref }}/assets/images/email/icon-attachment-image.svg">
          <div class="att-info">
            <span class="att-name" [title]="att.FileName">{{ att.FileName }}</span>
            <span class="att-size">{{ formatBytes(att.FileSize) }}</span>
          </div>
          <!-- <button class="att-download-btn" (click)="downloadAttachment(att)">Download</button> -->
        </div>
      </div>
    </div>
  </ng-container>

  <!-- 4. Email body -->
  <div class="section-divider"></div>
  <div class="body-section">
    <div class="email-body-content" [innerHTML]="sanitizedBody"></div>
    <div style="border: none; border-top: 1.5px solid #707070; margin: 0.25rem 0; display: none"></div>
  <!-- 5. Email chain -->
  <ng-container *ngIf="emailChain?.length > 0">
    <div class="section-divider"></div>
    <div class="chain-section">
      <ng-container *ngFor="let entry of emailChain; let last = last">
        <div class="chain-entry">
          <div class="chain-meta">
            <span class="chain-from">{{ entry.From }}</span>
            <span class="chain-date">{{ entry.ReceivedDate }}</span>
          </div>
          <div class="chain-body" [innerHTML]="entry.Body"></div>
        </div>
        <hr *ngIf="!last" class="chain-divider" />
      </ng-container>
    </div>
  </ng-container>
  </div>

</div><!-- /.view-body -->

</div><!-- /.view-email-container -->
